/** Maximum ECDIS targets per vessel. */
export const MAX_ECDIS_TARGETS = 5;

/** Polling interval for active transfers in milliseconds. */
export const TRANSFER_POLL_INTERVAL = 5_000;

/** Maximum retries for failed transfer targets. */
export const MAX_TRANSFER_RETRIES = 3;
